import Loadable from 'react-loadable';
import Loading from 'components/Loading';

const LoginInPage = Loadable({
  loader: () => import('./Containers/Login'),
  loading: Loading
});

const ActiveUser = Loadable({
  loader: () => import('./Containers/ActiveUser'),
  loading: Loading
});

const Logout = Loadable({
  loader: () => import('./Containers/Logout'),
  loading: Loading
});

const ConfirmEmail = Loadable({
  loader: () => import('./Containers/ConfirmEmail'),
  loading: Loading
});

const ResetPassword = Loadable({
  loader: () => import('./Containers/ResetPassword'),
  loading: Loading
});

const ForgotPassword = Loadable({
  loader: () => import('./Containers/ForgotPassword'),
  loading: Loading
});

const SSO = Loadable({
  loader: () => import('./Containers/SSO'),
  loading: Loading
});
const ExternalAuthenticator = Loadable({
  loader: () => import('./Containers/ExternalAuthenticator'),
  loading: Loading
});
export default [
  {
    path: '/sign-in',
    component: LoginInPage
  },
  {
    path: '/logout',
    component: Logout
  },
  {
    path: '/account/active-user',
    component: ActiveUser
  },
  {
    path: '/account/confirm-email',
    component: ConfirmEmail
  },
  {
    path: '/account/reset-password',
    component: ResetPassword
  },
  {
    path: '/account/forgot-password',
    component: ForgotPassword
  },
  {
    path: '/account/sso',
    component: SSO
  },
  {
    path: '/authenticate',
    component: ExternalAuthenticator
  }
];



// WEBPACK FOOTER //
// ./src/Auth/routes.js